module.exports = __webpack_public_path__ + "img/1574325672(1).3a56ad05.png";